(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.enSg = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    domain: '',
    menuToggle: {
      label: 'MENU'
    },
    logo: {
      href: '/'
    },
    mainBtn: [{
      text: 'TEST DRIVE',
      classes: 'btn-ghost hidden-xs gold',
      link: '/free-trial'
    }, {
      text: 'LOGIN',
      classes: 'btn-ghost hidden-xs concur-blue',
      link: ''
    }],
    siteLinks: [{
      title: {
        text: 'PRODUCTS'
      },
      list: [{
        text: 'Expense products',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'Concur Expense',
          src: '/expense-management'
        }, {
          text: 'Budget',
          src: '/budget-management'
        }, {
          text: 'Concur Drive',
          src: '/concur-drive'
        }, {
          text: 'Audit Services',
          src: '/travel-expense-audit-service'
        }, {
          text: 'Concur Request',
          src: '/expense-approval-system'
        }, {
          text: 'Payment Solutions',
          src: '/payment-solutions'
        }, {
          text: 'Travel & Expense',
          src: '/travel-expense'
        }, {
          text: 'Company Bill Statements',
          src: '/p-card-reconciliation'
        }]
      }, {
        text: 'Travel products',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'Concur Travel',
          src: '/travel-booking'
        }, {
          text: 'Concur Locate',
          src: '/concur-locate'
        }, {
          text: 'Budget',
          src: '/budget-management'
        }, {
          text: 'Concur Request',
          src: '/expense-approval-system'
        }, {
          text: 'Concur TripLink',
          src: '/triplink'
        }, {
          text: 'TripLink Connected Suppliers',
          src: '/triplink-supplier-connections'
        }, {
          text: 'Travel & Expense',
          src: '/travel-expense'
        }]
      }, {
        text: 'Invoice products',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'Concur Invoice',
          src: '/invoice-management'
        }, {
          text: 'Invoice Capture',
          src: '/effortless-invoice-capture'
        }, {
          text: 'Concur Request',
          src: '/expense-approval-system'
        }, {
          text: 'Payment Solutions',
          src: '/payment-solutions'
        }]
      }, {
        text: 'Data insights',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'Budget',
          src: '/budget-management'
        }, {
          text: 'Consultative Intelligence',
          src: '/travel-expense-data-analysis'
        }, {
          text: 'Analytics',
          src: '/analytics'
        }, {
          text: 'Intelligence',
          src: '/business-intelligence'
        }]
      }, {
        text: 'Support',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'Service Administration',
          src: '/service-administration'
        }, {
          text: 'User Support Desk',
          src: '/user-support-desk'
        }, {
          text: 'Preferred Care',
          src: '/preferred-care'
        }]
      }, {
        text: 'Integrations',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'App Center',
          src: '/app-center'
        }, {
          text: 'Concur TripLink',
          src: '/triplink'
        }, {
          text: 'Platform',
          src: '/open-platform-apps'
        }, {
          text: 'SAP',
          src: '/sap-integration'
        }]
      }, {
        text: 'All products',
        src: '/all-products-page'
      }, {
        text: 'Expense Demo',
        src: '/self-guided-demo-expense-en-sg#/',
        classes: 'call-out'
      }, {
        text: 'Invoice Demo',
        src: '/self-guided-demo-invoice#/',
        classes: 'call-out'
      }]
    }, {
      title: {
        text: 'SOLUTIONS'
      },
      list: [{
        text: 'By business need',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'Business Growth',
          src: '/business-growth-solutions'
        }, {
          text: 'Duty of care',
          src: '/duty-of-care'
        }, {
          text: 'Fraud and compliance',
          src: '/compliance-fraud'
        }, {
          text: 'Intelligent Spend Management',
          src: '/intelligent-spend-management'
        }, {
          text: 'Productivity',
          src: '/productivity'
        }, {
          text: 'Strategic spend management',
          src: '/strategic-spend-management'
        }, {
          text: 'Visibility and control',
          src: '/visibility-and-compliance'
        }]
      }, {
        text: 'By industry',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'Financial Services',
          src: '/financial-services-solution'
        }, {
          text: 'Higher education',
          src: '/higher-education-expenses-software'
        }, {
          text: 'Healthcare',
          src: '/healthcare'
        }, {
          text: 'Oil, mine, and gas',
          src: '/oil-mine-gas'
        }, {
          text: 'Retail and restaurant',
          src: '/retail-and-restaurant'
        }]
      }, {
        text: 'By role',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'Finance',
          src: '/financial-manager-solutions'
        }, {
          text: 'IT',
          src: '/it-leader'
        }, {
          text: 'Travel',
          src: '/travel-manager'
        }]
      }, {
        text: 'All solutions',
        src: '/solutions'
      }, {
        text: 'Get quote',
        src: '/get-quote-form',
        classes: 'call-out'
      }]
    }, {
      title: {
        text: 'ABOUT US'
      },
      list: [{
        text: 'About SAP Concur',
        src: '/about-concur'
      }, {
        text: 'Executives',
        src: ''
      }, {
        text: 'Locations',
        src: '/contact/offices'
      }, {
        text: 'Careers',
        src: ''
      }, {
        text: 'Support',
        src: '/support'
      }, {
        text: 'CONTACT SALES',
        src: '/contact',
        classes: 'call-out'
      }]
    }, {
      title: {
        text: 'RESOURCES'
      },
      list: [{
        text: 'Newsroom',
        src: '/newsroom'
      }, {
        text: 'Resource Center',
        src: '/resource-centre'
      }, {
        text: 'Events',
        src: '/events'
      }, {
        text: 'Case Studies',
        src: '/casestudy'
      }, {
        text: 'Partners',
        src: '/partners'
      }, {
        text: 'App Center',
        src: '/app-center'
      }, {
        text: "What's New in Product",
        src: '/newsroom/c/whats-new'
      }]
    }],
    supportLinks: [{
      text: 'LOGIN',
      href: ''
    }, {
      text: 'SERVICE STATUS',
      href: ''
    }, {
      text: 'CONTACT SALES',
      href: '/contact'
    }, {
      text: 'REQUEST A QUOTE',
      href: '/get-quote-form'
    }, {
      text: 'SUPPORT',
      href: '/support'
    }],
    mobileAppText: {
      text: 'GET CONCUR MOBILE APP'
    }
  };
});